import React from "react";

const LeftArrow = () => {
  return (
    <svg
      width="6"
      height="13"
      viewBox="0 0 8 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{ mixBlendMode: "luminosity" }}>
        <path
          d="M6.40625 14.0234L0.328125 8.07812C0.117188 7.86719 0.0078125 7.63281 0.0078125 7.35938C0.0078125 7.08594 0.117188 6.83594 0.335938 6.63281L6.41406 0.695312C6.58594 0.523438 6.80469 0.429688 7.05469 0.429688C7.57812 0.429688 7.98438 0.835938 7.98438 1.35156C7.98438 1.60156 7.88281 1.84375 7.70312 2.02344L2.23438 7.35156L7.70312 12.6953C7.88281 12.875 7.98438 13.1094 7.98438 13.3672C7.98438 13.8828 7.57812 14.2891 7.05469 14.2891C6.80469 14.2891 6.58594 14.1953 6.40625 14.0234Z"
          fill="#797979"
        />
      </g>
    </svg>
  );
};

export default LeftArrow;
